import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    cookieName: String
  }
  static classes = ["collapsed"]

  toggle(event) {
    event.preventDefault()

    const collapsedClass = this.hasCollapsedClass ? this.collapsedClass : "is-collapsed"
    const isCollapsed = this.element.classList.toggle(collapsedClass)

    if (this.hasCookieNameValue && this.cookieNameValue) {
      this.setCookie(this.cookieNameValue, isCollapsed ? "true" : "false", 365)
    }
  }

  setCookie(name, value, days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    const expires = "expires=" + date.toUTCString()
    document.cookie = name + "=" + value + ";" + expires + ";path=/"
  }
}
